/**
 * SwiperJS -- https://swiperjs.com/get-started
 */

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default function() {
    // init the swiper
    const newSwiper = sliderElm =>  {
        let sliderData = JSON.parse(sliderElm.dataset.swiper);

        const swiper = new Swiper(sliderElm, {
            grid: sliderData.grid,
            autoplay: sliderData.autoplay,
            breakpoints: sliderData.breakpoints,
            slidesPerView: sliderData.slidesPerView,
            spaceBetween: sliderData.spaceBetween,
            loop: sliderData.loop,
            navigation: {
                //use section ids for correct slider association
                nextEl: '#' + sliderElm.closest('section').id + ' .swiper-button-next',
                prevEl: '#' + sliderElm.closest('section').id + ' .swiper-button-prev',
            }
        });
    }

    const sliders = document.querySelectorAll('.slider');
    sliders.forEach(slider => newSwiper(slider));
}
